<template>
  <div class="bodymain" style="width:100%;height:100%;overflow:hidden">
    <video
      ref="elememtVideo"
      id="av-player"
      class="emav"
      preload="auto"
      autoplay="true"
      playsinline
      webkit-playsinline
      :x5-playsinline="plata"
    ></video>
    <div class="zhezhao" v-show="buybtn">
      <div v-if="showPurchase">
        <p class="zhe_title">试看结束，购买后查看完整内容</p>
        <p class="zhe_buy" @click="buyCourse">购买课程</p>
      </div>
      <div v-else>
        <p class="zhe_title">试看结束</p>
        <p class="zhe_buy temp">敬请期待</p>
      </div>
      <div @click="replay" class="zhe_replay">
        <img src="../../../public/images/course/sk.png" alt />
      </div>
    </div>
    <div
      class="zhezhao_img"
      v-if="!dataList.bought&&!dataList.free&&trybtn"
      :style="'backgroundImage:url('+imgUrl+')'"
    >
      <!-- <p style="font-size:0.4rem;color:#fff;padding-top:0.5rem">{{imgName}}</p>
      <p @click="tryplay" class="tryplay_btn free_try" v-if="dataList.free" v-cloak>
        <img src="../../../public/images/course/trylearn1.png" alt />
      </p>
      <p
        @click="boughtplay"
        class="tryplay_btn free_try"
        v-else-if="dataList.bought&&!dataList.free"
        v-cloak
      >
        <img src="../../../public/images/course/trylearn1.png" alt />
      </p>-->
      <p @click="tryplay" class="tryplay_btn">
        <img src="../../../public/images/course/trylearn.png" alt />
      </p>
    </div>
    <div class="play" v-show="playshow == 1">
      <span class="play_close" @click="playShowClick">×</span>
      <span class="play_time">
        记忆您上次看到
        <span>{{titleTime}}</span>
      </span>
      <span class="play_jump" @click="starTime=1;playJump();">跳转播放</span>
    </div>
    <ul class="nav" ref="elememtNav">
      <li
        ref="elememtFree1"
        v-if="dataList.free"
        @click="tabnum = 2;FreeCourselist(1, 1);bought=0;tryIndex=0;change=0;"
        :class="{ active: tabnum == 2 }"
        class="nav_free"
      >最近更新</li>
      <li
        ref="elememtFree2"
        v-if="dataList.free"
        @click="tabnum = 3;FreeCourselist(2, 1);bought=0;tryIndex=0;change=0;"
        :class="{ active: tabnum == 3 }"
        class="nav_free"
      >最热播放</li>
      <li
        v-if="!dataList.free"
        @click="tabnum = 0;change=0;"
        :class="{ active: tabnum == 0 }"
        class="nav_pay"
        ref="elememtNavPay1"
      >详情</li>
      <li
        v-if="!dataList.free"
        @click="tabnum = 1;change=0;"
        :class="{ active: tabnum == 1 }"
        class="nav_pay"
        ref="elememtNavPay2"
      >目录</li>
    </ul>
    <div class="scrollWrap" ref="infoAll">
      <div :style="contentHeight" v-show="tabnum == 0" class="content content0" ref="elementMain">
        <div class="video_main">
          <p class="video_title" v-html="titleName"></p>
          <p class="video_buy">
            ￥
            <span>{{dataList.price}}</span>
          </p>
          <!-- <p class="video_old">
            ￥
            <span>{{dataList.originalPrice}}</span>
          </p>-->
          <p class="video_people">
            <!-- <span>{{dataList.purchaseQuantity}}</span>人已购 -->
          </p>
        </div>
        <div class="video_content">
          <div class="video_content_main" v-for="(value,key,index) in courselistImg" :key="index">
            <img :src="value" alt />
          </div>
        </div>
        <!-- <div class="chat_top" @click="askUrl">
          <img src="../../../public/images/course/chattop.png" alt />
        </div>-->
      </div>
      <div
        :style="contentHeight"
        v-show="tabnum == 1"
        class="content content1"
        ref="elementContent"
      >
        <div class="content_ml">
          <div v-for="(item,index) in videoList" :key="item.channelId">
            <div class="control">
              <progressCircle
                :radius="radius"
                :alldata.sync="dataList"
                :option.sync="item"
                :index.sync="index"
                :rowactive.sync="row==item.channelId?row:''"
                @click.native="row=item.channelId;change=1;getVideo(item.channelId,item.courseId,item.bought,item.playtime,index);getIndex(index);starTime=0;changeImg=0"
              ></progressCircle>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="contentHeight1"
        v-show="tabnum == 2"
        class="content content2"
        ref="elementContentFree"
        @touchmove="handleScroll1"
        @scroll="handleScroll1"
      >
        <div class="content_ml" ref="elementFree_ml">
          <div v-for="(item,index) in videoList" :key="item.channelId">
            <div class="control">
              <progressCircle
                :radius="radius"
                :alldata.sync="dataList"
                :option.sync="item"
                :index.sync="index"
                :rowactive.sync="row==item.channelId?row:''"
                @click.native="changeShare(item.channelId);row=item.channelId;change=1;getVideo(item.channelId,item.courseId,item.bought,item.playtime,index);getIndex(index);starTime=0;changeImg=0"
              ></progressCircle>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="contentHeight1"
        v-show="tabnum == 3"
        class="content content3"
        ref="elementContentFreeHot"
        @touchmove="handleScroll2"
        @scroll="handleScroll2"
      >
        <div class="content_ml" ref="elementHot_ml">
          <div v-for="(item,index) in videoList" :key="item.channelId">
            <div class="control">
              <progressCircle
                :radius="radius"
                :alldata.sync="dataList"
                :option.sync="item"
                :index.sync="index"
                :rowactive.sync="row==item.channelId?row:''"
                @click.native="changeShare(item.channelId);row=item.channelId;change=1;getVideo(item.channelId,item.courseId,item.bought,item.playtime,index);getIndex(index);changeImg=0"
              ></progressCircle>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" ref="elementFooter" v-if="!dataList.free&&!dataList.bought" v-cloak>
      <!-- <div class="footer_img" @click="askUrl">
        <img src="../../../public/images/course/chatbuy.png" alt />
      </div>-->
      <div style="margin:0 auto;width:5.64rem;height:1.18rem;">
        <div class="foort_buy" v-if="(!dataList.bought)&&(!dataList.free)">
          <button @click="buyCourse" v-if="showPurchase">订阅课程</button>
          <!-- 研究所更新 -->
          <button class="temp" v-else>敬请期待</button>
        </div>
        <!-- <div class="footer_free" v-if="(!dataList.bought)&&(!dataList.free)" @click="open">
          <button>限时开户免费领</button>
        </div>-->
      </div>
    </div>
    <div class="zhezhao_all" @click="freeSuccess=0" v-show="freeSuccess==1">
      <div class="freeBuy">
        <img src="../../../public/images/course/free.png" alt />
      </div>
    </div>
    <div
      v-show="payShow"
      style="position:fixed;top:0;width:100%;height:100%;background-color:#000;opacity:0.7;z-index:1000"
    ></div>
    <div
      v-show="payShow"
      style="width:5rem;height:3rem;margin:auto;background-color:#fff;position:absolute;top:0;left:0;opacity:1;right:0;bottom:0;z-index:1001;border-radius:10px;"
    >
      <p style="font-size:0.38rem;color:#474747;text-align:center;margin:0.8rem 0 0.72rem;">是否已支付完成</p>
      <div style="border-top:1px solid #ddd;padding:0 0.2rem;">
        <p
          @click="paycancel"
          style="float:left;background-color:#fff;width:2.2rem;height:0.9rem;line-height:0.9rem;font-size:0.28rem;"
        >取消</p>
        <p
          @click="payok"
          style="float:left;background-color:#fff;width:2.3rem;height:0.9rem;line-height:0.9rem;font-size:0.28rem;border-left:1px solid #ddd;"
        >确认</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PlayVideo,
  CourseDetail,
  RefreShtime,
  Subscribe,
  RemoveSubscribe,
  FreeCourselist
} from "../../utils/http";
import progressCircle from "../../components/progressCircle";
import { setCookie, getCookie } from "../../utils/cookie";
import config from "../../utils/config";
import jsonp from "jsonp";
// import emH5Share from "../emH5Share.js";
export default {
  name: "courseInfo",
  components: {
    progressCircle
  },
  data() {
    return {
      payShow: false,
      starTime: 0,
      row: "",
      tabnum: 0,
      buybtn: false,
      trybtn: "",
      boughtbtn: true,
      imgsrc: "",
      isposter: true,
      bought: true,
      numTitle: 1,
      playshow: 0,
      isLogin: 0,
      currenttime: "",
      isjump: 0,
      dataList: [],
      videoList: [],
      courseId: "",
      timer: "",
      ctoken: "",
      utoken: "",
      channelId: "",
      firstClick: 0,
      app: {},
      jumpTime: 0,
      radius: "0.64rem",
      jumpTimer: null,
      change: 0,
      starUrl: "",
      titleName: "",
      titleTime: 0,
      freeSuccess: 0,
      boughtSuccess: 0,
      tryIndex: 0,
      courselistImg: {},
      freeCourse: false,
      videoHotList: [],
      videoNewList: [],
      Freebought: 1,
      isLoadingMore: false,
      pauseTitle: "",
      imgUrl: "",
      imgName: "",
      changeImg: 0,
      ct: "",
      ut: "",
      BackPage: "",
      top: 0,
      isScroll_top: true,
      isScrill_bottom: false,
      contentHeight: {
        height: "calc(100vh - 4.12rem)"
      },
      contentHeight1: {
        height: "calc(100vh - 4.85rem)"
      },
      plat: "",
      plata: 0,
      nickName: "",
      showPurchase: true,
      miniToken: ""
      // ct:
      //   "CmPi-LA5DBERuf6mQNipCvYDjuj7yeSB0VPr7X8W_7-sJCbg01nJhjXkYSjnZDfQkWAE5Y8nkBNI3f7I_RGtSIsNUTztAkHLqClBFOQXNoAiBdJQJ_0sTL48RNlJtO031AHTjEMKx6skhHExISUwTj9YKB39_4HX2Bm-Hu7d-eQ",
      // ut:
      //   "FobyicMgeV5n3saZh_euZy--p-b-m95qr3GbuHHdQQG2w0EIw50d3E4kvwZLJyA32cul8HN-5UbiKVsviCWfbsCdROSlQd0JZscMT6KyNKzHmk9_8hzKsopO_y8WHGwf1yqGPj-vQCJTd2EuUZzTAn7X6MAJtf8iUCVxvE3RdSkD_oJ4G67iqtXyS8ru7qnfP25gXfcnj_ZQpz_-SCCKijKgRQOj8dGrCGICJO4bhW6_wW8dwQXmWMvIhgdFUVVZrHNd7cugGmKJTZ1f8sZlhLvCZ2XBvFdS"
      // ct:
      //   "Z-4U1AqdSuG4N9Aen-TfXV1hcF2bMdNHfqGQYl2-TQ7TD_Jxu7SbgmYfkD-geCtlFq5rKH09JB6z7m_lcOhr4iq9a28V2SFCKWYRujeWEJNkETz7i53OUrBsBmEHqerer2xFaz2mX-u6HqVoVtYyoHqW3pmn4iDervInM2U7uT0",
      // ut:
      //   "FobyicMgeV5n3saZh_euZy--p-b-m95qr3GbuHHdQQG2w0EIw50d3E4kvwZLJyA32cul8HN-5UbiKVsviCWfbsCdROSlQd0JZscMT6KyNKzHmk9_8hzKsopO_y8WHGwf1yqGPj-vQCJTd2EuUZzTAn7X6MAJtf8iUCVxvE3RdSkD_oJ4G67iqtXyS8ru7qnfP25gXfcnj_ZQpz_-SCCKiiD2zCvJzCGHB7NSm7r-ZrmYHU-k7u5Y39C4_xKMpelBqChqQkVZFeMaI3m8yDF5RY-HnzASCXFf"
    };
  },
  watch: {
    $route: "getParams",
    dataList: {
      handler: function(newval) {
        if (newval.bought) {
          this.contentHeight = {
            height: "calc(100vh - 4.85rem)"
          };
        } else {
          this.contentHeight = {
            height: "calc(100vh - 6rem)"
          };
        }
      },
      deep: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    window.AG.setTitle("课程");
    window.onNetChange = json => {
      if (JSON.parse(json).type != "Wifi") {
        this.$alert("正在使用流量播放");
      }
    };
    const json = '{"callbackname":"onNetChange"}';
    if (window.AG.InApp) {
      this.showPurchase = false;
      if (navigator.userAgent.indexOf("Android") > -1) {
        prompt("emGetNetStatus", json);
      } else {
        eastmoney.emGetNetStatus(json);
      }
    }
    // window.AG.getModuleInfo('deviceInfo', (json)=> {
    //     if (+json.code === 0) {
    //         if (json.data.deviceInfo.network !== 'WIFI') {
    //             window.AG.alert('正在使用流量播放');
    //         }
    //     }
    // })
    // var that = this;
    // window.AG.checkUserIsLogin(function(result) {
    //   if (result) {
    //     that.isLogin = 1;
    //     window.AG.getUserLoginSuccessData(function(json) {
    //       that.ctoken = json.ct;
    //       that.utoken = json.ut;
    //       that.nickName = json.nickname;
    //       that.getParams();
    //     });
    //   } else {
    //     that.ctoken = "";
    //     that.utoken = "";
    //     that.getParams();
    //     that.isLogin = 0;
    //   }
    // });
    if (window.AG.InApp) {
      var that = this;
      window.AG.checkUserIsLogin(function(result) {
        if (result) {
          that.isLogin = 1;
          window.AG.getUserLoginSuccessData(function(json) {
            that.ctoken = json.ct;
            that.utoken = json.ut;
            that.nickName = json.nickname;
            that.getParams();
          });
        } else {
          that.ctoken = "";
          that.utoken = "";
          that.getParams();
          that.isLogin = 0;
        }
      });
    } else {
      this.ctoken = getCookie("ct");
      this.utoken = getCookie("ut");
      if (this.ctoken && this.utoken) {
        this.isLogin = 1;
        this.getParams();
      } else {
        this.ctoken = "";
        this.utoken = "";
        this.getParams();
        this.isLogin = 0;
      }
    }

    this.overscroll(document.querySelector(".content0"));
    this.overscroll(document.querySelector(".content1"));
    this.overscroll(document.querySelector(".content2"));
    this.overscroll(document.querySelector(".content3"));
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.addEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
    if (/(MicroMessenger)/i.test(navigator.userAgent)) {
      this.plat = "weixin";
      if (this.plat == "weixin") {
        this.plata = 1;
        console.log(this.plata);
      }
    }
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.app.dispose();
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.removeEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
    // clearInterval(this.jumpTimer);
  },
  methods: {
    changeShare(channelId) {
      var title = this.videoList.filter(item => item.channelId == channelId)[0]
        .name;
      var desc = "为您精选投资课程";
      // emH5.ShareData = {
      //   title: title,
      //   desc: desc,
      //   link: window.location.href,
      //   // imgUrl:
      //   //   "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
      //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
      //   fail: function(res) {
      //     alert(JSON.stringify(res));
      //   }
      // };
      // emH5.Share();
    },
    initVideo() {
      this.app = window.emav("av-player", {
        autoplay: true,
        controls: true,
        width: "4.75rem",
        height: "4.12rem",
        posterImage: true,
        bigPlayButton: true,
        poster: "",
        controlBar: {
          children: [
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "progressControl",
            "fullscreenToggle"
          ],
          // playToggle: true,
          // volumePanel: true,
          remainingTimeDisplay: false,
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          progressControl: true,
          playbackRateMenuButton: true,
          fullscreenToggle: true
        },
        theme: {
          name: "mobile",
          playProgressColor: "#e95700",
          loadProgressColor: "#fff",
          controlBar: [
            "currentTimeDisplay",
            "progressControl",
            "durationDisplay",
            "fullscreenToggle"
          ]
        },
        bigPlayButton: true,
        showBigPlayButtonOnPaused: true,
        pausedView: {
          title: "",
          color: "#fff",
          fontSize: 1.8,
          fullscreenFontSize: 3.8
        },
        progressTracker: {
          backgroundColor: "#e95700",
          height: 0.2
        },
        fastXWard: {
          color: "#e95700"
        },
        statistic: {
          activeTime: true
        }
      });
    },
    listenScroll(evt) {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    overscroll(el) {
      el.addEventListener("touchstart", function() {
        var top = el.scrollTop,
          totalScroll = el.scrollHeight,
          currentScroll = top + el.offsetHeight;
        if (top === 0) {
          el.scrollTop = 1;
        } else if (currentScroll === totalScroll) {
          el.scrollTop = top - 1;
        }
      });

      el.addEventListener("touchmove", function(evt) {
        if (el.offsetHeight < el.scrollHeight) {
          evt._isScroller = true;
        }
      });
    },
    handleScroll1() {
      // 页面滚动距顶部距离
      var scrollTop = this.$refs.elementContentFree.scrollTop;
      var scroll = scrollTop - this.top;
      this.top = scrollTop;
      if (scroll >= 0) {
        this.srollTest1();
      }
    },
    handleScroll2() {
      // 页面滚动距顶部距离
      var scrollTop = this.$refs.elementContentFreeHot.scrollTop;
      var scroll = scrollTop - this.top;
      this.top = scrollTop;
      if (scroll >= 0) {
        this.srollTest2();
      }
    },
    srollTest1() {
      if (
        this.$refs.elementContentFree.scrollTop +
          this.$refs.elementContentFree.offsetHeight >
        this.$refs.elementFree_ml.offsetHeight - 30
      ) {
        if (this.isLoadingMore) {
          return;
        }
        this.isLoadingMore = true;
        this.page++;
        this.FreeCourselist(this.tabnum - 1, this.page);
      }
    },
    srollTest2() {
      if (
        this.$refs.elementContentFreeHot.scrollTop +
          this.$refs.elementContentFreeHot.offsetHeight >
        this.$refs.elementHot_ml.offsetHeight - 30
      ) {
        if (this.isLoadingMore) {
          return;
        }
        this.isLoadingMore = true;
        this.page++;
        this.FreeCourselist(this.tabnum - 1, this.page);
      }
    },
    getHeight() {
      let heightVideo = this.$refs.elememtVideo.offsetHeight;
      let heightNav = this.$refs.elememtNav.offsetHeight;
      let heightWindow = window.innerHeight;
      let heightFooter = this.$refs.elementFooter.offsetHeight;
      let heightMain = heightWindow - heightVideo - heightNav - heightFooter;
      console.log(heightMain);
      if (this.dataList.bought) {
        heightMain = heightWindow - heightVideo - heightNav;
        console.log(heightMain);
      }
      // let heightMain = heightWindow - heightVideo - heightNav - heightFooter;
      let heightMain_free = heightWindow - heightVideo - heightNav;
      this.$refs.elementMain.style.height = heightMain + "px";
      this.$refs.elementContent.style.height = heightMain + "px";
      this.$refs.elementContentFree.style.height = heightMain_free + "px";
      this.$refs.elementContentFreeHot.style.height = heightMain_free + "px";
    },
    getVideo(v, w, x, t, index) {
      this.tryIndex = index;
      if (!this.dataList.free) {
        CourseDetail({
          courseId: w,
          ctoken: this.ctoken || this.ct,
          utoken: this.utoken || this.ut
        }).then(res => {
          if (res.data.code == 0) {
            this.dataList = res.data.data;

            this.videoList = res.data.data.videoList;
          }
        });
      }
      var list;
      list = this.videoList;
      var that = this;
      // if (this.changeImg == 0) {
      //   this.app.pausedView.titleEl_.innerHTML = list[this.tryIndex].name;
      // } else {
      //   this.app.pausedView.titleEl_.innerHTML = this.dataList.name;
      //   this.changeImg = 0;
      // }

      if (x == false && !list[index].previewVideo && !this.dataList.free) {
        this.buyCourse();
      } else {
        this.channelId = v;
        this.jumpTime = t ? t : 0;
        this.bought = x;
        if (this.dataList.free) {
          for (var i = 0; i < list.length; i++) {
            if (i == index) {
              this.titleName = list[i].name;
            }
          }
        }
        // if (!this.bought || this.dataList.free) {
        //   this.app.play();
        // }
        // if (this.dataList.free) {
        //   this.playshow = 0;
        // } else {
        //   if (this.jumpTime == 0) {
        //     this.playshow = 0;
        //   } else {
        //     this.playshow = 1;
        //   }
        // }
        PlayVideo({
          channelId: v,
          courseId: w,
          ctoken: this.ctoken || this.ct,
          utoken: this.utoken || this.ut
        }).then(res => {
          if (res.data.code == 0) {
            if (this.changeImg == 0) {
              this.app.pausedView.titleEl_.innerHTML = list[this.tryIndex].name;
            } else {
              this.app.pausedView.titleEl_.innerHTML = this.dataList.name;
              this.changeImg = 0;
            }
            if (this.dataList.free) {
              this.app.poster(res.data.data.recordImgUrl);
            }

            // this.app.play();z
            this.app.src(res.data.data.videoUrl);
            this.showAlert();
            this.trybtn = false;
            this.boughtbtn = false;
            this.buybtn = false;
            this.courseId = w;
            this.channelId = v;
            this.isposter = false;
            this.jumpTimer = null;
            var that = this;
            var time;
            if (this.starTime == 1) {
              time = t;
            } else {
              time = 0;
            }
            if (!this.dataList.free) {
              this.app.on("timeupdate", function() {
                // var time = that.app.currentTime();
                if (
                  that.app.currentTime() - time > 30 &&
                  that.app.currentTime() <= list[index].duration
                ) {
                  time = that.app.currentTime();
                  RefreShtime({
                    channelId: that.channelId,
                    courseId: that.courseId,
                    playtime: that.app.currentTime(),
                    ctoken: that.ctoken || that.ct,
                    utoken: that.utoken || that.ut
                  }).then(res => {
                    if (res.data.code == 0) {
                      // that.currenttime = time;
                    }
                  });
                } else if (
                  that.app.currentTime() < time &&
                  parseInt(that.app.currentTime()) != 0
                ) {
                  time = that.app.currentTime();
                  RefreShtime({
                    channelId: that.channelId,
                    courseId: that.courseId,
                    playtime: that.app.currentTime(),
                    ctoken: that.ctoken || that.ct,
                    utoken: that.utoken || that.ut
                  }).then(res => {
                    if (res.data.code == 0) {
                      // that.currenttime = time;
                    }
                  });
                }

                if (!list[index].bought) {
                  if (list[index].previewVideo && !that.dataList.free) {
                    if (that.app.currentTime() >= 300) {
                      that.app.pause();
                      that.buybtn = true;
                    }
                    if (list[index].duration <= 300) {
                      that.app.on("ended", function() {
                        that.buybtn = true;
                      });
                    }
                  } else {
                    that.buybtn = false;
                  }
                }
              });
            }
            if (this.dataList.free) {
              this.playshow = 0;
            } else {
              if (this.jumpTime == 0) {
                this.playshow = 0;
              } else {
                this.playshow = 1;
              }
            }
            // if (this.dataList.free) {
            //   this.playshow = 0;
            // } else {
            //   if (this.jumpTime == 0) {
            //     this.playshow = 0;
            //   } else {
            //     this.playshow = 1;
            //     // this.jumpTimer = setTimeout(() => {
            //     //   that.playshow = 0;
            //     //   that.jumpTimer = null;
            //     // }, 10000);
            //   }
            // }
            // this.app.on("play", function() {
            //   // if (that.app.currentTime() == 0) {
            //   if (that.dataList.free) {
            //     that.playshow = 0;
            //   } else {
            //     if (that.jumpTime == 0) {
            //       that.playshow = 0;
            //     } else {
            //       that.playshow = 1;
            //     }
            //     if (that.jumpTime > 0) {
            //       // that.jumpTimer = setTimeout(() => {
            //       //   that.playshow = 0;
            //       //   // that.jumpTimer = null;
            //       // }, 10000);
            //     }
            //   }
            //   // }
            // });
            if (!this.dataList.free) {
              this.app.on("ended", function() {
                RefreShtime({
                  channelId: that.channelId,
                  courseId: that.courseId,
                  playtime: list[index].duration,
                  ctoken: that.ctoken || that.ct,
                  utoken: that.utoken || that.ut
                }).then(res => {
                  if (res.data.code == 0) {
                    // that.currenttime = time;
                  }
                });
              });
            }
            var that = this;
            this.app.on("ended", function() {
              if (window.AG.InApp) {
              } else {
                var u = navigator.userAgent;
                var isAndroid =
                  u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                if (isAndroid) {
                  that.app.play(0);
                  setTimeout(() => {
                    that.app.pause();
                  }, 100);
                }
              }
            });
          }
        });
        this.timeStamp(this.jumpTime);
      }
    },
    showAlert() {
      if (window.AG.InApp) {
        window.AG.getModuleInfo("deviceInfo", json => {
          if (+json.code === 0) {
            if (json.data.deviceInfo.network !== "WIFI") {
              this.$alert("正在使用流量播放");
            }
          }
        });
      }
    },
    courseDetail(v) {
      CourseDetail({
        courseId: v,
        ctoken: this.ctoken || this.ct,
        utoken: this.utoken || this.ut
      }).then(res => {
        if (res.data.code == 0) {
          this.trybtn = true;
          this.dataList = res.data.data;
          this.titleName = this.dataList.name;
          if (res.data.data.free) {
            this.tabnum = 2;
            this.FreeCourselist(1, 1);
            this.imgName = this.dataList.name;
            this.imgUrl = this.dataList.videoList[0].recordImgUrl;
            let that = this;
            this.app = window.emav("av-player", {
              // autoplay: false,
              controls: true,
              width: "4.75rem",
              height: "4.12rem",
              posterImage: true,
              bigPlayButton: true,
              poster: that.dataList.videoList[0].recordImgUrl,
              controlBar: {
                children: [
                  "currentTimeDisplay",
                  "timeDivider",
                  "durationDisplay",
                  "progressControl",
                  "fullscreenToggle"
                ],
                // playToggle: true,
                // volumePanel: true,
                remainingTimeDisplay: false,
                currentTimeDisplay: true,
                timeDivider: true,
                durationDisplay: true,
                progressControl: true,
                playbackRateMenuButton: true,
                fullscreenToggle: true
              },
              theme: {
                name: "mobile",
                playProgressColor: "#e95700",
                loadProgressColor: "#fff",
                controlBar: [
                  "currentTimeDisplay",
                  "progressControl",
                  "durationDisplay",
                  "fullscreenToggle"
                ]
              },
              bigPlayButton: true,
              showBigPlayButtonOnPaused: true,
              pausedView: {
                title: that.dataList.videoList[0].name,
                color: "#fff",
                fontSize: 1.8,
                fullscreenFontSize: 3.8
              },
              progressTracker: {
                backgroundColor: "#e95700",
                height: 0.2
              },
              fastXWard: {
                color: "#e95700"
              },
              statistic: {
                activeTime: true
              }
            });
            this.app.src(this.dataList.videoList[0].channelId);
            this.showAlert();
          } else {
            if (this.isLogin == 0) {
              if (window.AG.InApp) {
                window.AG.eventLogin(res => {
                  if (+res.code === 0) {
                    window.EM_USER_LOGIN_INFO = res.data;
                    this.ctoken = res.data.ct;
                    this.utoken = res.data.ut;
                    this.nickName = decodeURIComponent(res.data.nickname);
                    this.isLogin = 1;
                    location.reload();
                  }
                });
              } else {
                var currentUrl = location.href;
                location.href =
                  "https://mpassport.eastmoney.com/login?backUrl=" +
                  encodeURIComponent(currentUrl);
                //跳转登录页
              }
            }
            this.$refs.elememtNavPay1.style.display = "block";
            this.$refs.elememtNavPay2.style.display = "block";
            let that = this;
            this.videoList = res.data.data.videoList;
            this.app = window.emav("av-player", {
              // autoplay: false,
              controls: true,
              width: "4.75rem",
              height: "4.12rem",
              posterImage: true,
              bigPlayButton: true,
              poster: that.dataList.videoList[0].recordImgUrl,
              controlBar: {
                children: [
                  "currentTimeDisplay",
                  "timeDivider",
                  "durationDisplay",
                  "progressControl",
                  "fullscreenToggle"
                ],
                // playToggle: true,
                // volumePanel: true,
                remainingTimeDisplay: false,
                currentTimeDisplay: true,
                timeDivider: true,
                durationDisplay: true,
                progressControl: true,
                playbackRateMenuButton: true,
                fullscreenToggle: true
              },
              theme: {
                name: "mobile",
                playProgressColor: "#e95700",
                loadProgressColor: "#fff",
                controlBar: [
                  "currentTimeDisplay",
                  "progressControl",
                  "durationDisplay",
                  "fullscreenToggle"
                ]
              },
              bigPlayButton: true,
              showBigPlayButtonOnPaused: true,
              pausedView: {
                title: that.dataList.videoList[0].name,
                color: "#fff",
                fontSize: 1.8,
                fullscreenFontSize: 3.8
              },
              progressTracker: {
                backgroundColor: "#e95700",
                height: 0.2
              },
              fastXWard: {
                color: "#e95700"
              },
              statistic: {
                activeTime: true
              }
            });
            if (res.data.data.bought) {
              this.app.src(this.dataList.videoList[0].channelId);
              this.showAlert();
            }
            if (!res.data.data.bought) {
              for (var i = 0; i < this.videoList.length; i++) {
                if (this.videoList[i].previewVideo) {
                  this.imgUrl = this.videoList[i].recordImgUrl;
                  this.channelId = this.videoList[i].channelId;
                  this.jumpTime = this.videoList[i].playtime || 0;
                  this.bought = this.videoList[i].bought;
                  this.imgName = this.videoList[i].name;
                  this.timeStamp(this.jumpTime);
                  this.tryIndex = i;
                  this.boughtSuccess = 1;
                }
              }
              this.$refs.elementFooter.style.display = "block";
            } else {
              this.imgUrl = this.videoList[0].recordImgUrl;
              this.imgName = this.videoList[0].name;
              this.channelId = this.videoList[0].channelId;
              this.jumpTime = this.videoList[0].playtime || 0;
              this.bought = this.videoList[0].bought;
              this.timeStamp(this.jumpTime);
              this.tryIndex = 0;
              this.boughtSuccess = 1;
            }
            if (res.data.data.bought) {
              let that = this;
              var time;
              if (this.starTime == 1) {
                time = this.jumpTime;
              } else {
                time = 0;
              }
              if (this.jumpTime == 0) {
                this.playshow = 0;
              } else {
                this.playshow = 1;
              }
              if (!res.data.data.free) {
                this.app.on("timeupdate", function() {
                  // var time = that.app.currentTime();
                  if (
                    that.app.currentTime() - time > 30 &&
                    that.app.currentTime() <= that.videoList[0].duration
                  ) {
                    // console.log(that.app.currentTime());
                    time = that.app.currentTime();
                    RefreShtime({
                      channelId: that.channelId,
                      courseId: that.courseId,
                      playtime: that.app.currentTime(),
                      ctoken: that.ctoken || that.ct,
                      utoken: that.utoken || that.ut
                    }).then(res => {
                      if (res.data.code == 0) {
                        // that.currenttime = time;
                      }
                    });
                  } else if (that.app.currentTime() < time) {
                    time = that.app.currentTime();
                    RefreShtime({
                      channelId: that.channelId,
                      courseId: that.courseId,
                      playtime: that.app.currentTime(),
                      ctoken: that.ctoken || that.ct,
                      utoken: that.utoken || that.ut
                    }).then(res => {
                      if (res.data.code == 0) {
                        // that.currenttime = time;
                      }
                    });
                  }
                });
              }
              this.jumpTimer = null;
              if (this.jumpTime > 0) {
                this.jumpTimer = setTimeout(() => {
                  this.playshow = 0;
                }, 4000);
              }
              this.app.on("play", function() {
                if (res.data.data.free) {
                  that.playshow = 0;
                } else {
                  if (that.jumpTime > 0) {
                    that.jumpTimer = setTimeout(() => {
                      that.playshow = 0;
                    }, 4000);
                  }
                }
              });
              if (!res.data.data.free) {
                this.app.on("ended", function() {
                  RefreShtime({
                    channelId: that.channelId,
                    courseId: that.courseId,
                    playtime: that.videoList[0].duration,
                    ctoken: that.ctoken || that.ct,
                    utoken: that.utoken || that.ut
                  }).then(res => {
                    if (res.data.code == 0) {
                      // that.currenttime = time;
                    }
                  });
                });
              }
            }
          }
          // this.playshow = 0;
          this.$refs.infoAll.style.display = "block";
          var that = this;
          this.app.on("ended", function() {
            if (window.AG.InApp) {
            } else {
              var u = navigator.userAgent;
              var isAndroid =
                u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
              if (isAndroid) {
                that.app.play(0);
                setTimeout(() => {
                  that.app.pause();
                }, 100);
              }
            }
          });
          // emH5.ShareData = {
          //   title: this.titleName,
          //   desc: "为您精选投资课程",
          //   link: window.location.href,
          //   // imgUrl:
          //   //   "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
          //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
          //   fail: function(res) {
          //     alert(JSON.stringify(res));
          //   }
          // };
          // emH5.Share();
        }
      });
    },
    replay() {
      this.buybtn = false;
      this.app.currentTime(0);
      this.app.play();
    },
    tryplay() {
      this.trybtn = false;
      this.isposter = false;
      if (this.dataList.free) {
        // this.app.play();
        this.changeImg = 1;
        this.getVideo(
          this.dataList.courseId,
          this.dataList.courseId,
          this.bought,
          this.jumpTime,
          this.tryIndex
        );
      } else {
        // this.app.play();
        this.getVideo(
          this.channelId,
          this.dataList.courseId,
          this.bought,
          this.jumpTime,
          this.tryIndex
        );
      }
    },
    boughtplay() {
      this.boughtbtn = false;
      this.trybtn = false;
      // this.app.play();
      this.getVideo(
        this.channelId,
        this.courseId,
        this.bought,
        this.jumpTime,
        this.tryIndex
      );
    },
    getParams() {
      this.courseId = this.$route.query.courseId;
      this.getImgList(this.courseId);
      if (!this.courseId) {
        this.courseId = getCookie("courseId");
      }
      this.courseDetail(this.courseId);

      var expireDays = 1;
      setCookie("courseId", this.courseId, expireDays);
    },
    playJump() {
      this.isjump = 1;
      var m;
      if (this.dataList.free) {
        m = this.channelId;
      } else {
        m = this.dataList.courseId;
      }
      this.app.currentTime(this.jumpTime);
      this.playshow = 0;
    },
    playShowClick() {
      this.playshow = 0;
      // this.change = 0;
    },
    askUrl() {
      window.location.href =
        "https://premium.eastmoney.com/tgIM/?FromContent=" +
        this.dataList.name +
        "&FromType=1&teacher=" +
        this.dataList.teacher +
        "&avataIco=" +
        encodeURIComponent(this.dataList.imageUrl) +
        "&env=";
    },
    paycancel() {
      this.payShow = false;
      window.location.reload();
    },
    payok() {
      this.payShow = false;
      window.location.reload();
    },
    buyCourse() {
      if (window.AG.InApp) {
        return;
      }
      var url =
        config.buyApi +
        "?productId=" +
        this.dataList.courseId +
        "&paySuccessUrl=" +
        "&backUrl=" +
        "&miniToken=" +
        this.miniToken;
      if (window.AG.InApp) {
        if (window.AG.ISIOS) {
          location.href = `eastmoney://wireless/txtrade/h5?requestTradeLogin=0&url=${url}`;
          this.jumpTimer = setInterval(() => {
            var that = this;
            window.AG.checkUserIsLogin(function(result) {
              if (result) {
                that.isLogin = 1;
                window.AG.getUserLoginSuccessData(function(json) {
                  that.ctoken = json.ct;
                  that.utoken = json.ut;
                  that.nickName = json.nickname;
                  // that.getParams();
                  window.location.reload();
                });
              } else {
                that.ctoken = "";
                that.utoken = "";
                that.getParams();
                window.location.reload();
                that.isLogin = 0;
              }
            });
          }, 2000);
        } else {
          location.href = `dfcft://webpayh5?url=${encodeURIComponent(url)}`;
          this.jumpTimer = setInterval(() => {
            var that = this;
            window.AG.checkUserIsLogin(function(result) {
              if (result) {
                that.isLogin = 1;
                window.AG.getUserLoginSuccessData(function(json) {
                  that.ctoken = json.ct;
                  that.utoken = json.ut;
                  that.nickName = json.nickname;
                  // that.getParams();
                  // window.location.reload();
                });
              } else {
                that.ctoken = "";
                that.utoken = "";
                // that.getParams();
                window.location.reload();
                that.isLogin = 0;
              }
            });
          }, 2000);
          this.payShow = true;
        }
      } else {
        url =
          config.buyApi +
          "?productId=" +
          this.dataList.courseId +
          "&paySuccessUrl=" +
          "&backUrl=" +
          encodeURIComponent(location.href) +
          "&miniToken=" +
          this.miniToken;
        location.href = url;
      }
    },
    timeStamp(second_time) {
      var time = parseInt(second_time) + "秒";
      if (parseInt(second_time) > 60) {
        var second = parseInt(second_time) % 60;
        var min = parseInt(second_time / 60);
        time = min + "分" + second + "秒";

        if (min > 60) {
          min = parseInt(second_time / 60) % 60;
          var hour = parseInt(parseInt(second_time / 60) / 60);
          time = hour + "小时" + min + "分" + second + "秒";
        }
      }
      this.titleTime = time;
    },
    getIndex(v) {
      this.tryIndex = v;
      this.bought = this.videoList[v].bought;
    },
    recourseDetail(w) {
      CourseDetail({
        courseId: w,
        ctoken: this.ctoken || this.ct,
        utoken: this.utoken || this.ut
      }).then(res => {
        if (res.data.code == 0) {
          this.dataList = res.data.data;
          if (this.dataList.free) {
            this.tabnum = 2;
            this.FreeCourselist(1, 1);
          } else {
            this.videoList = res.data.data.videoList;
          }
        }
      });
    },
    openTradeWebView(v) {
      let url = v;
      if (window.AG.InApp) {
        if (window.AG.ISIOS) {
          location.href = `eastmoney://wireless/txtrade/h5?requestTradeLogin=0&url=${url}`;
        } else {
          location.href = `dfcft://quicktrade?tradeflag=webh5&url=${encodeURIComponent(
            url
          )}`;
        }
      } else {
        location.href = v;
      }
    },
    open() {
      let url =
        config.getApi +
        "?id=" +
        this.courseId +
        "&avatarUrl=" +
        this.dataList.imageUrl +
        "&teacher=" +
        this.dataList.teacher;
      // let url =
      //   "http://premiumtest.eastmoney.com/mall#/card?id=" +
      //   this.courseId +
      //   "&avatarUrl=" +
      //   this.dataList.imageUrl +
      //   "&teacher=" +
      //   this.dataList.teacher;
      // let url =
      //   "https://premium.eastmoney.com/mall#/card?id=" +
      //   this.courseId +
      //   "&avatarUrl=" +
      //   this.dataList.imageUrl +
      //   "&teacher=" +
      //   this.dataList.teacher;
      this.openTradeWebView(url);
    },
    // "http://premiumtest.eastmoney.com/appapi/api/TrialVersionAdvertising/Get?type=14",
    getImgList(v) {
      const url =
        process.env.VUE_APP_VERSION == "prod"
          ? "https://premiumapi.eastmoney.com/app"
          : "http://premiumtest.eastmoney.com/appapi";
      jsonp(
        url + "/api/TrialVersionAdvertising/Get?type=14",
        { name: "cb", param: "cb" },
        (err, data) => {
          if (err) {
            console.error(err.message);
          } else {
            var listlength = data.Data.length;
            for (var i = 0; i < data.Data.length; i++) {
              var strlist = data.Data[i].SkipUrl.split("_");
              if (this.courseId == strlist[0]) {
                this.courselistImg[strlist[1]] = data.Data[i].ImgUrl;
              }
            }
            // console.log(this.courselistImg);
          }
        }
      );
    },
    alertTips(title, content) {
      var jsonStr =
        '{"title":"' +
        title +
        '","content":"' +
        content +
        '","okbt":{"name":"关闭","event":"eventOK"},"cnacelbt":null}';
      if (window.AG.ISIOS) {
        //IOS
        window.location = "emH5toNativeAlterView:" + jsonStr;
      } else {
        //Android
        prompt("emH5toNativeAlterView", jsonStr + "$&&$" + "java.lang.String");
      }
    },
    FreeCourselist(type, page) {
      FreeCourselist({
        listType: type,
        pageNum: page,
        pageSize: 10,
        ctoken: this.ctoken || this.ct,
        utoken: this.utoken || this.ut
      }).then(res => {
        if (res.data.code == 0) {
          // var imgUrl;
          this.$refs.elememtFree1.style.display = "block";
          this.$refs.elememtFree2.style.display = "block";
          if (page == 1) {
            this.videoList = res.data.data;
            // this.imgUrl = this.videoList[this.tryIndex].recordImgUrl;
            // this.imgName = this.videoList[this.tryIndex].name;
            // imgUrl = this.videoList[this.tryIndex].recordImgUrl;
            this.channelId = this.videoList[this.tryIndex].channelId;
            this.jumpTime = this.videoList[this.tryIndex].playtime;
            this.bought = this.videoList[this.tryIndex].bought;
            this.page = page;
            this.isLoadingMore = false;
          } else {
            if (res.data.data.length != 0) {
              this.videoList = this.videoList
                .slice(0, this.videoList.length)
                .concat(res.data.data);
              this.isLoadingMore = false;
              this.page = page;
              this.imgUrl = this.videoList[this.tryIndex].recordImgUrl;
              this.imgName = this.videoList[this.tryIndex].name;
              // imgUrl = this.videoList[this.tryIndex].recordImgUrl;
              this.channelId = this.videoList[this.tryIndex].channelId;
              this.jumpTime = this.videoList[this.tryIndex].playtime;
              this.bought = this.videoList[this.tryIndex].bought;
            } else {
              this.page = page;
              this.isLoadingMore = true;
            }
          }
          this.playshow = 0;
        }
      });
    }
  }
};
</script>
<style scoped>
.zhezhao {
  position: absolute;
  top: 0;
  width: 100%;
  height: 4.12rem;
  background-color: #000;
  z-index: 1000;
  /* opacity: 0.9; */
}
.zhezhao_img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 4.12rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 1000;
}
.zhezhao_all {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 1000;
  /* opacity: 0.8; */
}
.poster {
  position: absolute;
  top: 0;
  width: 100%;
  height: 4.12rem;
}
.tryplay_btn {
  width: 2.4rem;
  height: 0.8rem;
  margin: 1.57rem auto 0;
}
.free_try {
  width: 1.7rem;
  height: 0.6rem;
  /* margin: 0.4rem auto 0; */
  background-color: #333333;
  border: 2px solid #fff;
  border-radius: 10px 10px;
  padding: 0.15rem 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -0.85rem;
  margin-top: -0.3rem;
}
.free_try img {
  width: 0.7rem;
  height: 0.6rem;
}
.play {
  position: absolute;
  top: 2.8rem;
  left: 0.3rem;
  height: 0.6rem;
  background-color: #000;
  opacity: 0.8;
  border-radius: 10px 10px;
}
.play_close {
  float: left;
  line-height: 0.6rem;
  font-size: 0.4rem;
  color: #fff;
  margin: 0 0.1rem;
}
.play_time {
  float: left;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.18rem;
  color: #fff;
  margin-right: 0.1rem;
}
.play_jump {
  float: left;
  line-height: 0.6rem;
  font-size: 0.18rem;
  color: #f44336;
  padding-right: 0.1rem;
}
/*  */
.emav {
  width: 7.5rem;
  height: 4.12rem;
}
.nav {
  width: 7.5rem;
  height: 0.73rem;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #cccccc;
}
.nav li {
  float: left;
  width: 3.75rem;
  /* height: 0.68rem; */
  height: calc(0.73rem - 4px);
  line-height: 0.68rem;
  text-align: center;
  color: #676767;
  font-size: 0.3rem;
}
.nav .active {
  color: #eb5604;
  border-bottom: 4px solid #eb5604;
}
.nav_pay,
.nav_free {
  display: none;
}
.main {
  width: 100%;
}
.scrollWrap {
  display: none;
}
.content {
  /* padding-bottom: 1.4rem; */
  width: 7.5rem;

  /* height: 200px; */
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
}
.content_ml {
  width: 7.5rem;
  margin: 0 auto;
}
.content li {
  width: 7.15rem;
  height: 1.1rem;
  padding: 0.28rem 0;
  border-bottom: 1px solid #efefef;
}
.main_left {
  float: left;
  padding: 0.25rem 0;
  width: 0.6rem;
  height: 0.6rem;
}
.main_left span {
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  line-height: 0.6rem;
  border-radius: 50%;
  font-size: 0.35rem;
  color: #ffffff;
}
.main_left .title_num1 {
  background-color: #f56415;
}
.main_left .title_num2 {
  background-color: #ff9933;
}
.main_left .title_num3 {
  background-color: #ffcc99;
}
.main_left .title_num4 {
  background-color: #cccccc;
}
.main_middle {
  float: left;
  padding-left: 0.35rem;
}
.course_title {
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.35rem;
  text-align: left;
  width: 4rem;
  overflow: hidden;
}
.course_time {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.3rem;
  color: #999999;
  text-align: left;
}
.main_right {
  float: right;
  /* padding: 0.8rem 0 0.2rem; */
}
.main_right_img {
  width: 1.8rem;
  height: 1rem;
}
.main_right_img img {
  width: 100%;
  height: 100%;
}
.video_btn {
  float: left;
  width: 1.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
  color: #ea5503;
  border: 1px solid #ea5503;
  border-radius: 10px 10px;
  background-color: #fff;
  font-size: 0.25rem;
  text-align: center;
  margin-top: 0.2rem;
}
/*  */
.video_main {
  padding-left: 0.21rem;
  height: 1.9rem;
  background-color: #fff;
}
.video_title {
  float: left;
  width: 100%;
  height: 0.95rem;
  line-height: 0.95rem;
  font-size: 0.35rem;
  font-weight: bold;
  text-align: left;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.video_buy {
  float: left;
  /* width: 100%; */
  height: 0.51rem;
  line-height: 0.15rem;
  font-size: 0.28rem;
  color: #e85505;
  text-align: left;
  vertical-align: text-top;
  margin-right: 0.2rem;
}
.video_buy span {
  font-size: 0.5rem;
  vertical-align: text-bottom;
}
.video_old {
  float: left;
  /* width: 100%; */
  height: 0.41rem;
  line-height: 0.2rem;
  font-size: 0.2rem;
  color: #333333;
  text-align: left;
  vertical-align: text-top;
  background: url("../../../public/images/course/line.png") no-repeat;
  background-size: 1.43rem 0.37rem;
  padding-top: 0.1rem;
}
.video_old span {
  font-size: 0.29rem;
  vertical-align: text-bottom;
}
.video_people {
  float: left;
  width: 100%;
  height: 0.45rem;
  line-height: 0.45rem;
  font-size: 0.25rem;
  color: #9a9a9a;
  text-align: left;
  text-indent: 0.1rem;
}
.video_content {
  width: 7.5rem;
  /* height: 8.2rem; */
  background-color: #f6f6f6;
  padding-top: 0.18rem;
}
.video_content_main {
  background-color: #fff;
  width: 7.5rem;
}
/* .video_content_img {
  width: 7.5rem;
}
.video_content_img img {
  width: 7.5rem;
} */
.footer {
  position: fixed;
  bottom: 0;
  width: 7.5rem;
  height: 1.18rem;
  background-color: #fff;
  border-top: 1px solid #cccccc;
  display: none;
}
.footer_img {
  float: left;
  padding: 0.27rem 0.34rem 0.21rem;
  width: 0.8rem;
  height: 0.7rem;
}
.footer_img img {
  width: 100%;
  height: 100%;
}
.foort_buy {
  float: left;
  /* padding: 0.27rem 0.26rem 0.21rem 0.3rem; */
  padding: 0.27rem 0 0.21rem;
  /* width: 2.09rem; */
  height: 0.7rem;
}
.foort_buyfree,
.foort_cancelfree {
  float: left;
  padding: 0.27rem 0.26rem 0.21rem 0.9rem;
  width: 4.09rem;
  height: 0.7rem;
}
.foort_buyfree button {
  float: left;
  width: 4.09rem;
  height: 0.7rem;
  line-height: 0.7rem;
  border: none;
  font-size: 0.27rem;
  font-weight: bold;
  color: #fefefe;
  background-color: #0189ff;
  border-radius: 20px 20px;
}
.foort_cancelfree button {
  float: left;
  width: 4.09rem;
  height: 0.7rem;
  line-height: 0.7rem;
  border: none;
  font-size: 0.27rem;
  font-weight: bold;
  color: #fefefe;
  background-color: #ddd;
  border-radius: 20px 20px;
}
.foort_buy button {
  float: left;
  /* width: 2.09rem; */
  width: 5.64rem;
  height: 0.7rem;
  line-height: 0.7rem;
  border: none;
  font-size: 0.27rem;
  font-weight: bold;
  color: #fefefe;
  /* background-color: #0189ff; */
  background-color: #ff6600;
  border-radius: 10px 10px;
}
.foort_buy button.temp {
  background-color: #999;
}
.footer_free {
  float: left;
  padding: 0.27rem 0 0.21rem;
}
.footer_free button {
  float: left;
  width: 2.99rem;
  height: 0.7rem;
  line-height: 0.7rem;
  border: none;
  font-size: 0.27rem;
  font-weight: bold;
  color: #fefefe;
  background-color: #ff6600;
  border-radius: 20px 20px;
}
.chat_top {
  width: 1.06rem;
  height: 1.19rem;
  position: fixed;
  right: 0;
  bottom: 1.7rem;
}
.chat_top img {
  width: 100%;
  height: 100%;
}
.circle-chart {
  margin: 0 0.64rem;
}

.zhe_title {
  width: 7.5rem;
  height: 0.6rem;
  line-height: 0.6rem;
  color: #fff;
  font-size: 0.36rem;
  margin: 0.57rem auto 0;
}
.zhe_buy {
  width: 2.4rem;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.34rem;
  background-color: #e85505;
  color: #fff;
  margin: 0.6rem auto 0;
  border-radius: 10px 10px;
}
.zhe_buy.temp {
  background-color: #999;
}
.zhe_replay {
  width: 1.2rem;
  height: 0.45rem;
  margin: 0.7rem 0 0 0.1rem;
}
.freeBuy {
  position: absolute;
  top: 40%;
  left: 2.7rem;
  width: 2rem;
  height: 2rem;
}

.click_active {
  background-color: #e3e3e3;
}
button:focus {
  outline: 0;
}
button {
  outline: none;
  -webkit-appearance: none;
  border: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
[v-cloak] {
  display: none;
}
</style>